<template>
  <v-dialog v-model="dialogo" width="400" persistent>
    <v-form @submit.prevent="enviar">
      <v-card>
        <v-card-title>
          Produto
          <v-spacer></v-spacer>
          <v-btn @click="fechar()" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            v-model="produto.produto"
            @input="handleMudancaProduto"
            :items="produtos"
            :loading="carregandoProdutos"
            item-value="id"
            item-text="nome"
            label="Produto"
            filled
            return-object
            :error-messages="erros.produto_id"
          >
            <template v-slot:item="{ item, on, attrs }">
              <v-list-item
                v-bind="attrs"
                v-on="on"
                :disabled="item.quantidade_disponivel < 1"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.nome }}
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="item.quantidade_disponivel > 0">
                    Disponível: {{ item.quantidade_disponivel }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-else>
                    Sem estoque
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="caption">
                  {{ formatMoney(item.preco) }}
                </v-list-item-action>
              </v-list-item>
            </template>
            <template v-slot:selected="{ item }">
              {{ item.nome }} ({{ item.quantidade_disponivel }})
            </template>
          </v-autocomplete>

          <v-row>
            <v-col>
              <v-text-field
                v-model="produto.data_inicial"
                label="Data inicial"
                type="date"
                filled
                :error-messages="erros.data_inicial"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="produto.data_final"
                label="Data final"
                type="date"
                filled
                :error-messages="erros.data_final"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="produto.quantidade"
                label="Quantidade"
                type="number"
                filled
                min="1"
                :hint="
                  quantidade_maxima ? 'Máximo: ' + quantidade_maxima : undefined
                "
                :max="quantidade_maxima || 0"
                :error-messages="erros.quantidade"
              >
              </v-text-field>
            </v-col>
            <v-col>
              <MoneyInput
                v-model="produto.preco_unitario"
                label="Preço Unitário"
                filled
                :error-messages="erros.preco_unitario"
              ></MoneyInput>
            </v-col>
          </v-row>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>
                Total
              </v-list-item-subtitle>
              <v-list-item-title>
                {{ formatMoney(total) }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="erros.total" class="red--text">
                {{ erros.total[0] }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="fechar()" text> Cancelar </v-btn>
          <v-btn color="primary" type="submit">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import MoneyInput from "@/components/MoneyInput.vue";
import MoneyMixin from "@/mixins/MoneyMixin.js";
import api from "@/services/locacoes.js";
import alerts from "@/mixins/alerts.js";
import dateTimeMixin from "@/mixins/DateTimeMixin";

export default {
  components: {
    MoneyInput
  },

  props: {
    locacao_id: Number
  },

  mixins: [MoneyMixin, alerts, dateTimeMixin],

  data() {
    return {
      dialogo: false,
      produto: {},
      produtos: [],
      carregandoProdutos: false,
      quantidade_maxima: null,
      sincronizarPreco: false,
      erros: {}
    };
  },

  methods: {
    limparErros() {
      this.erros = {};
    },

    handleErro(erro) {
      console.error(erro);

      if (erro.response && erro.response.status === 422) {
        this.erros = erro.response.data.errors;
        return;
      }
      if (erro.response && erro.response.data.message) {
        this.error(erro.response.data.message);
        return;
      }

      this.error("Não foi possível executar a ação");
    },

    async abrir(produto = null) {
      this.limparErros();
      this.preencherProduto(produto);
      this.dialogo = true;
      await this.carregarProdutos();
      this.sincronizarPreco = true;
    },

    preencherProduto(produto = null) {
      if (produto === null) {
        this.produto = {
          quantidade: 1,
          data_inicial: this.formatDateISO(new Date())
        };
        return;
      }

      this.produto = {
        ...produto,
        produto: {
          id: produto.produto_id + "_" + produto.dias,
          id_produto: produto.produto_id,
          dias: produto.dias
        },
        data_inicial: produto.data_inicial || this.formatDateISO(new Date())
      };
    },

    fechar() {
      this.dialogo = false;
      this.sincronizarPreco = false;
    },

    async handleMudancaProduto(novoProduto) {
      this.quantidade_maxima = novoProduto.quantidade_disponivel;

      this.produto = {
        ...this.produto,
        preco_unitario: novoProduto.preco
      };
    },

    async carregarProdutos() {
      this.carregandoProdutos = true;

      try {
        this.produtos = await api.products.listarPorPreco();
      } catch (error) {
        console.error(error);
        this.error("Não foi possível carregar os produtos");
      } finally {
        this.carregandoProdutos = false;
      }
    },

    parsePayload(produto) {
      console.log(produto);

      return {
        data_inicial: produto.data_inicial,
        data_final: produto.data_final,
        preco_unitario: produto.preco_unitario,
        quantidade: produto.quantidade,
        produto_id: produto.produto?.id_produto,
        dias: produto.produto?.dias
      };
    },

    async enviar() {
      this.limparErros();
      try {
        const locacao = this.produto.id
          ? await api.locacoes.atualizarProduto(
              this.locacao_id,
              this.produto.id,
              this.parsePayload(this.produto)
            )
          : await api.locacoes.adicionarProduto(
              this.locacao_id,
              this.parsePayload(this.produto)
            );

        this.sendMessage("Produto adicionado com sucesso");

        this.fechar();

        this.$emit("product_added", locacao);
      } catch (error) {
        this.handleErro(error);
      }
    },

    async atualizarPrecoUnitario() {
      if (!this.sincronizarPreco) {
        return;
      }

      if (!this.produto.produto_id) {
        return;
      }

      if (!this.produto.data_inicial) {
        return;
      }

      if (!this.produto.data_final) {
        return;
      }

      const response = await api.precos_produto.calcularPorData(
        this.produto.produto_id,
        {
          data_inicial: this.produto.data_inicial,
          data_final: this.produto.data_final
        }
      );

      this.$nextTick().then(() => {
        this.produto.preco_unitario = response.preco;
      });
    }
  },

  computed: {
    total() {
      if (!this.produto) {
        return 0;
      }

      return this.produto.quantidade * this.produto.preco_unitario;
    }
  }
};
</script>
